import React from 'react';
import { Tab, TabWrapper } from './styled';
import { AGENTS, CLOUD_AGENTS, RUN_STATUS_LOG } from './constants';
import { useDispatch } from 'react-redux';
import { setAgentsEntity } from 'store/Agents/actions';
import { RUNNERS_ENTITY, AGENTS_EXECUTION_ENTITY } from 'store/Agents/reducer';

const Tabs = ({ onToggleAgents, selectedTab, setSelectedTab }) => {
  const dispatch = useDispatch();

  return (
    <TabWrapper>
      <Tab isActive={ selectedTab === AGENTS } onClick={ () => { dispatch(setAgentsEntity(RUNNERS_ENTITY)); setSelectedTab(AGENTS); } }>Runners</Tab>
      <Tab isActive={ selectedTab === CLOUD_AGENTS } onClick={ () => onToggleAgents() } >Security Scanners</Tab>
      <Tab isActive={ selectedTab === RUN_STATUS_LOG } onClick={ () => { dispatch(setAgentsEntity(AGENTS_EXECUTION_ENTITY)); setSelectedTab(RUN_STATUS_LOG); } }>Run Status Log</Tab>
    </TabWrapper>
  );
};

export default Tabs;
